var body = $('body');

var SWIPER_SCRIPTS_LOADED = false;

export function loadScripts(array, callback) {
    var loader = function(src, handler) {
        var script = document.createElement("script");
        script.src = src;
        script.onload = script.onreadystatechange = function() {
            script.onreadystatechange = script.onload = null;
            if (/MSIE ([6-9]+\.\d+);/.test(navigator.userAgent)) window.setTimeout(function() { handler(); }, 8, this);
            else handler();
        }
        var body = document.getElementsByTagName("body")[0];
        (body || document.body).appendChild(script);
    };
    (function run() {
        if (array.length != 0) {
            loader(array.shift(), run);
        } else {
            callback && callback();
        }
    })();
}

$(function() {
    var teacherUrl = $('#teacher-detail');
    if (teacherUrl.length > 0) {
        var link = window.location.pathname;
        if (link != teacherUrl.val()) {
            window.history.replaceState({}, "", teacherUrl.val());
        }
        tech.core.setPageVisitCookie();
    }
    if ($('#course-carousel-home').length > 0) {
        var video = $('#course-carousel-home video');
        if (video.length > 0) {
            $('#course-carousel-home').on('slide.bs.carousel', function(ev) {
                if (ev.from != ev.to && ev.to == 0 && video[0].ended) {
                    video[0].play();
                }
            })
        }

    }
    body.one('click', loadSwipers);
    body.one('keydown', loadSwipers);
    body.one('mousemove', loadSwipers);
    body.one('touchstart', loadSwipers);
})

function loadSwipers(){
    if (!SWIPER_SCRIPTS_LOADED) {
        loadScripts([
            "/js/swiper.min.js",
            "/js/swiper-init.js"
        ])
        SWIPER_SCRIPTS_LOADED = true;
    }
    body.off('click', loadSwipers);
    body.off('keydown', loadSwipers);
    body.off('mousemove', loadSwipers);
    body.off('touchstart', loadSwipers);
}